<ng-container *ngIf="viewModel$ | async as vm">
  <div *ngIf="vm.visible" class="ssrm-select-all-banner" [class.all-matching]="vm.mode === 'all-matching'">
    <!-- Page-prompt state: "All N on this page selected. Select all M matching" -->
    <ng-container *ngIf="vm.mode === 'page-prompt'">
      <div class="banner-content">
        <span class="banner-text">
          All {{ pluralize(itemLabel) }} on this page are selected.
        </span>
        <a
          mat-button
          color="primary"
          (click)="onSelectAllMatchingClick()"
          [disabled]="vm.inProgress"
          [attr.aria-busy]="vm.inProgress"
        >
          <ng-container *ngIf="!vm.inProgress">Select all {{ vm.itemTotal }} {{ pluralize(itemLabel) }}</ng-container>
          <span *ngIf="vm.inProgress" class="banner-spinner-wrap">
            <span class="banner-spinner" aria-hidden="true"></span>
            Selecting all {{ vm.itemTotal }} {{ pluralize(itemLabel) }}…
          </span>
        </a>
      </div>
      <div class="banner-close">
        <button
          mat-icon-button
          (click)="onDismissClick()"
          aria-label="Dismiss prompt"
          title="Dismiss"
        >
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </ng-container>

    <!-- All-matching state: "All M selected. Clear selection" -->
    <ng-container *ngIf="vm.mode === 'all-matching'">
      <div class="banner-content">
        <span class="banner-text">
          All&nbsp;<strong>{{ vm.itemTotal }}</strong>&nbsp;{{ pluralize(itemLabel) }} are selected.
        </span>
        <a mat-button color="primary" (click)="onClearSelectionClick()">Clear selection</a>
      </div>
    </ng-container>
  </div>
</ng-container>
